function resizeFacebookEmbeds() {
  if (typeof FB !== "undefined" && FB && FB.XFBML) {
    FB.XFBML.parse();
  }
}

window.addEventListener("load", resizeFacebookEmbeds);
